import _CircularProgress from "material-ui/CircularProgress";
import React, { useRef } from 'react';
import classnames from 'classnames';
import { LOGO_INPUT_ACCEPT } from 'swag-client-common/utils/constants';
import { ReactComponent as UploadLogoImage } from 'assets/svg/upload-logo.svg?react';
import deleteLogoIcon from 'assets/svg/delete-logo-icon.svg';
import classes from './logo-uploader.scss';
export function LogoUploader({
  handleLogoChange,
  currentLogo,
  logoWrapperClassName = null,
  logoBlockClassName = null,
  isLoading = false,
  buttonText = 'Upload your logo',
  fileExtension,
  isLogoDeletable = false,
  disabled = false,
  handleDeleteLogo
}) {
  const inputRef = useRef(null);
  const handleClear = () => {
    var _inputRef$current;
    if (inputRef !== null && inputRef !== void 0 && (_inputRef$current = inputRef.current) !== null && _inputRef$current !== void 0 && _inputRef$current.value) {
      inputRef.current.value = '';
    }
    if (handleDeleteLogo) {
      handleDeleteLogo();
    }
  };
  const getLogo = () => {
    if (currentLogo) {
      return /*#__PURE__*/React.createElement("img", {
        src: currentLogo,
        alt: "upload logo"
      });
    }
    return /*#__PURE__*/React.createElement(UploadLogoImage, null);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.logoBlock, logoBlockClassName)
  }, isLogoDeletable && currentLogo && /*#__PURE__*/React.createElement("button", {
    className: classes.deleteButton,
    onClick: handleClear
  }, /*#__PURE__*/React.createElement("img", {
    src: deleteLogoIcon,
    alt: "Delete notecard logo"
  })), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.logoWrapper, logoWrapperClassName)
  }, isLoading ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_CircularProgress, {
    size: 50
  })) : getLogo()), /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.button, {
      [classes.isDisabledButton]: isLoading
    })
  }, buttonText), /*#__PURE__*/React.createElement("input", {
    ref: inputRef,
    className: classes.logoUpload,
    accept: fileExtension ? fileExtension : LOGO_INPUT_ACCEPT,
    type: "file",
    onChange: handleLogoChange,
    disabled: disabled
  })));
}